const sidebarId = "sidebar-nav";
export { sidebarId };
